/**
 * Helper: Format
 * -----------------------------------------------------------------------------
 * Formats values and objects.
 * - Add in alphabetical order.
 *
 */

/**
 * Checks if the currency needs to be explicitly stated.
 * @returns {String} The active currency if it matches the current country
 */
export function formatCurrencyCode() {
  const showCurrencies = window.cnvs?.metafields?.global?.showCurrencies || []
  const currentCountry = window.Shopify?.country.toLowerCase() || ''

  if (currentCountry && showCurrencies.includes(currentCountry)) {
    return cnvs.store.currency
  }

  return ''
}

/**
 * Structures payload data for Klaviyo's Back in Stock subscription.
 * @param {FormData} data - Input form data.
 * @param {Number} variantId - Selected variant ID.
 * @returns {Object}
 */
export function formatKlaviyoBisData(data, variantId) {
  if (!data || !variantId) {
    return {}
  }

  const formattedData = {
    type: 'back-in-stock-subscription',
    attributes: {
      profile: {
        data: {
          type: 'profile',
          attributes: {
            email: data.get('email'),
          },
        },
      },
      channels: ['EMAIL'],
    },
    relationships: {
      variant: {
        data: {
          type: 'catalog-variant',
          id: `$shopify:::$default:::${variantId}`,
        },
      },
    },
  }

  return formattedData
}

/**
 * Structures the payload data for Klaviyo.
 *
 * @param {FormData} data - Input data from form.
 * @param {Boolean|Object} options - Optional options object.
 * @param {Boolean} options.includeProperties - If country and interests should
 * be included in this Klaviyo subscription.
 * @returns {Object}
 */
export function formatKlaviyoSubscriptionData(data, options = { includeProperties: true }) {
  const formattedData = {
    type: 'subscription',
    attributes: {
      custom_source: data.get('$source'),
      profile: {
        data: {
          type: 'profile',
          attributes: {
            email: data.get('email'),
          },
        },
      },
    },
    relationships: {
      list: {
        data: {
          type: 'list',
          id: data.get('g'),
        },
      },
    },
  }

  if (options?.includeProperties) {
    formattedData.attributes.profile.data.attributes.properties = {
      country: data.get('country'),
      interests: data.getAll('interest'),
    }
  }

  return formattedData
}

/**
 * Filters phone number inputs from any string data to only return its numbers.
 * Then, append it after a `+` for the area code.
 *
 * @param {String} phone - Phone number.
 * @returns {String}
 */
export function formatPhoneNumber(phone) {
  const phoneNumber = phone.replace(/\D/g, '')

  return ['+', phoneNumber].join('')
}
